import get11Data from './get11Data';
import getNetworkData from './getNetworkData';
import getPrimingUrls from './getPrimingUrls';
import handle11Agent from './handle11Agent';
import handleNon11Agent from './handleNon11Agent';
import logger from '../log';
import { PrimingData, MaybePrimingDataInput } from './interfaces';
import { setupDuration } from '../common/utils/duration';

const log = logger.getLogger(__filename);
const DEFAULT_TIMEOUT = 2000;

export default async function gatherPrimingData(
  maybePrimingData: MaybePrimingDataInput
): Promise<PrimingData> {
  log.info(maybePrimingData);
  const { config, iceCandidates, getIceCandidates } = maybePrimingData;
  const timeout = maybePrimingData.timeout || DEFAULT_TIMEOUT;
  const primingData = { ...maybePrimingData, timeout };
  const chunk = setupDuration();
  const { vals } = chunk;
  const base = { doThrow: false, timeout };
  const [ics, eleven, probe] = await Promise.all([
    getNetworkData({ base, config, vals, iceCandidates, getIceCandidates }),
    get11Data({ base, config, vals }),
    getPrimingUrls({ base, config, vals })
  ]);
  const input = { chunk, config, eleven, ics, primingData, probe };
  const call = eleven ? handle11Agent : handleNon11Agent;
  return await call(input);
}
